/**
 * Impersonation session store — tiny helper that outlives one page
 * navigation and holds the "you are impersonating X" metadata so the
 * banner survives full page reloads.
 *
 * The token itself is set by the backend as an httpOnly cookie on the
 * next authenticated request; this module only holds the *display*
 * data (target email/name + expiry) which is non-sensitive.
 */

const LS_KEY = "pfo_impersonation_v1";

export function startImpersonation({ session_token, target, expires_at }) {
  try {
    // Set an accessible bearer token cookie so subsequent axios calls
    // carry it. httpOnly is not possible from JS; the backend also sets
    // its own session cookie via /auth/session-style upgrade if needed.
    document.cookie = `session_token=${session_token}; path=/; max-age=${2 * 3600}; SameSite=None; Secure`;
    localStorage.setItem(LS_KEY, JSON.stringify({
      target: { user_id: target.user_id, email: target.email, name: target.name },
      expires_at,
      started_at: new Date().toISOString(),
    }));
  } catch (err) {
    console.warn("startImpersonation persist failed", err);
  }
}

export function getImpersonation() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Auto-clear if expired.
    if (parsed.expires_at && new Date(parsed.expires_at).getTime() < Date.now()) {
      localStorage.removeItem(LS_KEY);
      return null;
    }
    return parsed;
  } catch { return null; }
}

export function endImpersonation() {
  try {
    localStorage.removeItem(LS_KEY);
    document.cookie = "session_token=; path=/; max-age=0; SameSite=None; Secure";
  } catch (err) {
    console.warn("endImpersonation clear failed", err);
  }
}
